// Vendor
import * as React from 'react';
import { SPOT_BLACK } from '@thredup/styleguide/src/variables/colors';

// Internal
import { Logo } from '@src/svg/Logo';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

const FinalQuote: React.FC = () => {
  return (
    <>
      <div className="bg-brand-lighter mb-16 mt-20 p-8 md:p-20 text-center">
        <p
          {...DEFAULT_SAL_PROPS}
          data-sal="fade"
          className="text-lg md:text-2xl md:p-16 md:pb-6"
        >
          &ldquo;The &lsquo;normal&rsquo; of the past is not working for so many
          people in this country. It&apos;s not working for our planet.
          It&apos;s not working for our economy. We&rsquo;ve got to work to find
          another way. We can do better.&rdquo;
        </p>
        <p
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={SAL_DELAY * 2}
          className="font-bold uppercase tracking-wider"
        >
          – James Reinhart
        </p>
        <p
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={SAL_DELAY * 6}
          className="mt-1"
        >
          Co-founder and CEO, thredUP
        </p>
      </div>
      <div className="text-center mb-20">
        <Logo className="m-auto" fill={SPOT_BLACK} />
        <p>
          Inspiring a new generation of consumers to think secondhand first.
        </p>
      </div>
    </>
  );
};

export { FinalQuote };
